// extracted by mini-css-extract-plugin
export var centerText = "_fd-8";
export var container = "_fd-0";
export var doughnutContainer = "_fd-7";
export var legend = "_fd-a";
export var legendItemColorDisplay = "_fd-b";
export var legendItemLabel = "_fd-d";
export var legendItemValue = "_fd-c";
export var lg = "_fd-5";
export var maxWidth = "_fd-9";
export var md = "_fd-4";
export var responsive = "_fd-6";
export var sm = "_fd-3";
export var xs = "_fd-2";
export var xxs = "_fd-1";